import React from 'react'

//contexts
import { useFinanceContext } from '../../../../../_contexts/FinananceContex'


function Filter(props) {
    const financeContext = useFinanceContext()

    const handleFilter = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleFilter(name, val)
    }

    return (
        <form autoComplete="off" role="presentation" className="filter-standard">
            <div className="row">
                <div className="col">
                    <label htmlFor="project_id">
                        Проект
                    </label>
                    <select
                        id="project_id"
                        name="project_id"
                        onChange={handleFilter}
                    >
                        <option value="">Всички</option>
                        {financeContext.projects.map(project =>
                            <option key={project.id} value={project.id}>
                                {project.name}
                            </option>
                        )}
                    </select>
                </div>
                <div className="col">
                    <label htmlFor="fromdate">
                        От
                    </label>
                    <input
                        type="date"
                        onChange={handleFilter}
                        name="fromdate"
                        id="fromdate"
                    />
                </div>
                <div className="col">
                    <label htmlFor="todate">
                        До
                    </label>
                    <input
                        type="date"
                        onChange={handleFilter}
                        name="todate"
                        id="todate"
                    />
                </div>
                <div className="col">
                    <label htmlFor="name">
                        Търсене
                    </label>
                    <input
                        type="search"
                        placeholder="Въведете име"
                        onChange={handleFilter}
                        name="name"
                        id="name"
                    />
                </div>
            </div>
        </form>
    )
}

export default Filter